import ProductoShow from './ProductoShow'
export {ProductoShow}
export default ProductoShow
